/*eslint-disable multiline-ternary */
/*eslint-disable react/jsx-no-duplicate-props */
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import {
  ProviderBoardCertificateImage,
  SuccessCircle,
} from '../../../../../img/findcare/FindCareSVG';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import GenericButton from '../../../../../../Components/GenericButton/GenericButton';
import { t } from 'i18next';

const FacilityDetailedInformation = ({
  locationHandler,
  facilityDetails,
  addressIndex,
  affiliatedDoctorsAddress,
  ...otherProps
}) => {
  const {
    searchProviderParams: { Network },
    address,
    networksList,
  } = useSelector(({ findProvider }) => findProvider);
  const googleAddress =
    facilityDetails.Address?.length > 0 &&
    facilityDetails.Address[addressIndex].Coordinateds
      ? facilityDetails.Address[addressIndex].Coordinateds
      : '';
  const googleURL = `https://www.google.com/maps/dir/?api=1&origin=${address}&destination=${googleAddress}`;
  const formattingPhone = (phone) => {
    const Number = phone && phone.toString();
    if (Number) {
      if (Number.includes('-')) {
        const splitNumber = Number && Number.split('-');
        return (
          splitNumber &&
          `(${splitNumber[0]}) ${splitNumber[1]}-${splitNumber[2]}`
        );
      } else {
        const splitStrings = [];
        for (let i = 0; i < Number.length; i += 3) {
          splitStrings.push(Number.slice(i, i + 3));
        }
        return (
          splitStrings.length > 0 &&
          `(${splitStrings[0]}) ${splitStrings[1]}-${splitStrings[2]}${splitStrings[3]}`
        );
      }
    } else return;
  };
  return (
    <>
      <div className="provider-information find-provider-bottom-border">
        <Row className="primary-background-mobile-off row m-0 p-0 p-md-3">
          <Col sm={4} className="phone-info">
            <p className="primary-text paragraph-font phone-info-heading">
              {t('find_provider.phone')}
            </p>
            {facilityDetails.Phone !== '' && facilityDetails.Phone !== null ? (
              <a
                className="secondary-text paragraph-font"
                href={`tel:${facilityDetails.Phone}`}
              >
                {formattingPhone(facilityDetails?.Phone)}
              </a>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
          {(affiliatedDoctorsAddress?.BillingAddress ||
            (affiliatedDoctorsAddress?.FacilityServiceAddress &&
              affiliatedDoctorsAddress?.FacilityServiceAddress.length > 0) ||
            (affiliatedDoctorsAddress?.FacilityMailingAddress &&
              affiliatedDoctorsAddress?.FacilityMailingAddress.length > 0)) && (
            <Col sm={8} className="address-info mt-3 mt-md-0 p-md-0">
              <Row>
                {(affiliatedDoctorsAddress?.BillingAddress ||
                  affiliatedDoctorsAddress?.FacilityServiceAddress.length >
                    0) && (
                  <Col>
                    {affiliatedDoctorsAddress?.BillingAddress && (
                      <>
                        <p className="primary-text paragraph-font phone-info-heading mb-1">
                          {t('find_provider.provider_billing_address')}
                        </p>
                        {/*{doctorDetails.DoctorAfflFacilities &&
                doctorDetails.DoctorAfflFacilities.length ? ( */}
                        <p className="secondary-text paragraph-font">
                          {affiliatedDoctorsAddress?.BillingAddress.Address1 &&
                            affiliatedDoctorsAddress?.BillingAddress.Address1 +
                              ', '}
                          {affiliatedDoctorsAddress?.BillingAddress.Address2 &&
                            affiliatedDoctorsAddress?.BillingAddress.Address2 +
                              ', '}
                          {affiliatedDoctorsAddress?.BillingAddress.Address3 &&
                            affiliatedDoctorsAddress?.BillingAddress.Address3 +
                              ', '}
                          {affiliatedDoctorsAddress?.BillingAddress
                            .BillingOfficeName &&
                            affiliatedDoctorsAddress?.BillingAddress
                              .BillingOfficeName + ', '}
                          {affiliatedDoctorsAddress?.BillingAddress.City &&
                            affiliatedDoctorsAddress?.BillingAddress.City +
                              ', '}
                          {affiliatedDoctorsAddress?.BillingAddress.County &&
                            affiliatedDoctorsAddress?.BillingAddress.County +
                              ', '}
                          {affiliatedDoctorsAddress?.BillingAddress.State &&
                            affiliatedDoctorsAddress?.BillingAddress.State +
                              ', '}
                          {affiliatedDoctorsAddress?.BillingAddress
                            .PostalCode &&
                            affiliatedDoctorsAddress?.BillingAddress.PostalCode}
                        </p>
                      </>
                    )}
                    {affiliatedDoctorsAddress?.FacilityServiceAddress &&
                      affiliatedDoctorsAddress?.FacilityServiceAddress.length >
                        0 && (
                        <>
                          <p className="primary-text paragraph-font phone-info-heading mb-1">
                            {t('find_provider.provider_service_address')}
                          </p>
                          {/*{doctorDetails.DoctorAfflFacilities &&
                doctorDetails.DoctorAfflFacilities.length ? ( */}
                          <p className="secondary-text paragraph-font">
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .Address1 &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].Address1 + ', '}
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .Address2 &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].Address2 + ', '}
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .Address3 &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].Address3 + ', '}
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .City &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].City + ', '}
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .County &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].County + ', '}
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .State &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].State + ', '}
                            {affiliatedDoctorsAddress?.FacilityServiceAddress[0]
                              .PostalCode &&
                              affiliatedDoctorsAddress
                                ?.FacilityServiceAddress[0].PostalCode}
                          </p>
                        </>
                      )}
                  </Col>
                )}
                {affiliatedDoctorsAddress?.FacilityMailingAddress &&
                  affiliatedDoctorsAddress?.FacilityMailingAddress.length >
                    0 && (
                    <Col>
                      <p className="primary-text paragraph-font phone-info-heading">
                        {t('find_provider.provider_mailing_address')}
                      </p>
                      {/*{facilityDetails.Address && facilityDetails.Address.length ? ( */}
                      <p className="secondary-text paragraph-font">
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .Address1 &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .Address1 + ', '}
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .Address2 &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .Address2 + ', '}
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .Address3 &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .Address3 + ', '}
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .City &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .City + ', '}
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .County &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .County + ', '}
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .State &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .State + ', '}
                        {affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                          .PostalCode &&
                          affiliatedDoctorsAddress?.FacilityMailingAddress[0]
                            .PostalCode}
                      </p>
                    </Col>
                  )}
              </Row>
              {/*// ) : ( //{' '}
            <p className="no-data">{t('find_provider.data_not_available')}</p>
            // )} */}
              {/*{facilityDetails.Address && facilityDetails.Address.length > 1 && (
              <GenericButton
                className=" p-0 m-0 paragraph-font secondary-2 cursor-pointer provider-location-link secondary-text paragraph-font"
                variant="link"
                onClick={locationHandler}
              >
                {t('find_provider.other_service_locations')}
              </GenericButton>
            )} */}
            </Col>
          )}
          {/*<Col sm={4} className="mt-3 mt-md-0">
            <p className="secondary-text paragraph-font text-md-right">
              <Link to={googleURL} target="_blank">
                <span className="secondary-2">
                  {t('find_provider.directions')}
                </span>
              </Link>
              <br />
              {facilityDetails.Address?.length > 0 &&
                facilityDetails.Address[addressIndex].Distance &&
                `${facilityDetails.Address[addressIndex].Distance} mile${
                  Number(facilityDetails.Address[addressIndex].Distance) > 1
                    ? 's'
                    : ''
                }`}
            </p>
          </Col> */}
        </Row>
        {facilityDetails.InNetwork && (
          <Row className="m-0 p-0 pt-4 pb-4">
            <Col sm={12} className="p-0 m-0">
              <p className="w-100 primary-text paragraph-font provider-details-heading">
                {t('find_provider.networks')}
              </p>
            </Col>
            <Col sm={12} className="p-0">
              <Row className="p-0 pt-4">
                {facilityDetails.Networks?.length ? (
                  facilityDetails.Networks.map((item, index) => {
                    if (
                      networksList.findIndex((ele) => ele.value === item) !== -1
                    ) {
                      return (
                        <Col key={`network-${index}`} sm={4} className="mb-2">
                          {Network === item ? (
                            <p className="font-weight-bold provider-details-data">
                              <SuccessCircle className="success-circle" />
                              <span className="ml-2">{item}</span>
                            </p>
                          ) : (
                            <p className="provider-details-data">
                              <span>{item}</span>
                            </p>
                          )}
                        </Col>
                      );
                    }
                    return;
                  })
                ) : (
                  <Col sm={4} className="mb-2">
                    <p className="no-data">
                      {t('find_provider.data_not_available')}
                    </p>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        )}
      </div>
      <div className="provider-professional-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-3">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.hospital_details')}
          </p>
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.specialties')}</b>
            </p>
            {facilityDetails.Specialities?.length ? (
              facilityDetails.Specialities.map((item, index) => {
                return (
                  <p
                    className="provider-details-data"
                    key={`speciality-${index}`}
                  >
                    {item}
                  </p>
                );
              })
            ) : (
              <Col sm={12} className="mb-2 px-0">
                <p className="no-data">
                  {t('find_provider.data_not_available')}
                </p>
              </Col>
            )}
          </Col>
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.practice_type')}</b>
            </p>
            {facilityDetails?.PracticeTypes ? (
              <p className="provider-details-data">
                {facilityDetails?.PracticeTypes}
              </p>
            ) : (
              <Col sm={12} className="mb-2 px-0">
                <p className="no-data">
                  {t('find_provider.data_not_available')}
                </p>
              </Col>
            )}
          </Col>
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.credentials')}</b>
            </p>
            {facilityDetails.Credentials?.length ? (
              facilityDetails.Credentials.map((item, index) => {
                return (
                  <div
                    key={`credential-${index}`}
                    className="d-flex align-items-start mt-2 certificate-image"
                  >
                    <ProviderBoardCertificateImage className="provider-board-certificate" />
                    <div className="pl-3">
                      <p className="bord-certificte-data">{item}</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <Col sm={12} className="mb-2 px-0">
                <p className="no-data">
                  {t('find_provider.data_not_available')}
                </p>
              </Col>
            )}
          </Col>
        </Row>

        <Row className="m-0 p-0 pb-3">
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.affiliations')}</b>
            </p>
            {otherProps.children}
          </Col>
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.license_type')}</b>
            </p>
            {facilityDetails.LicenseType !== '' &&
            facilityDetails.LicenseType !== null ? (
              <p className="provider-details-data">
                {facilityDetails.LicenseType}
              </p>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.license_number')}</b>
            </p>
            {facilityDetails.LicenseNumber !== '' &&
            facilityDetails.LicenseNumber !== null ? (
              <p className="provider-details-data">
                {facilityDetails.LicenseNumber}
              </p>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
        </Row>
        <Row className="m-0 p-0 pb-4">
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.national_provider_id')}</b>
            </p>
            {facilityDetails.ProviderId !== '' &&
            facilityDetails.ProviderId !== null ? (
              <p className="provider-details-data">
                {facilityDetails.ProviderId}
              </p>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
          <Col sm={4} className="p-0">
            <p className="provider-details-data">
              <b>{t('find_provider.tax_id')}</b>
            </p>
            {facilityDetails.TaxID !== '' && facilityDetails.TaxID !== null ? (
              <p className="provider-details-data">{facilityDetails.TaxID}</p>
            ) : (
              <p className="no-data">{t('find_provider.data_not_available')}</p>
            )}
          </Col>
        </Row>
      </div>
      <div className="provider-facilities-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.facilities_location')}
          </p>
          {facilityDetails.ServicesAtCurrentLocation?.length ? (
            facilityDetails.ServicesAtCurrentLocation.map((item, index) => (
              <p className="provider-details-data w-100 mb-2" key={index}>
                {item}
              </p>
            ))
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
    </>
  );
};

export default FacilityDetailedInformation;
